export default __webpack_public_path__ + "static/media/squiggle.45a292da.png";